import { render } from "./VipSubscribe.vue?vue&type=template&id=c1e167e4&scoped=true"
import script from "./VipSubscribe.vue?vue&type=script&lang=js"
export * from "./VipSubscribe.vue?vue&type=script&lang=js"

import "./VipSubscribe.vue?vue&type=style&index=0&id=c1e167e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1e167e4"]])

export default __exports__